module.exports = __webpack_public_path__ + "img/10.6d5171f3.jpg";